<span *ngIf="column?.title" [innerHTML]="column.title"></span>

<ng-container *ngIf="column?.quantity">
  <span
    (click)="column.visibleDropdown = !column.visibleDropdown"
    (clickOutside)="column.visibleDropdown = false"
    class="table-header-unit-control"
  >
    ({{ column.currentUnit.value }})
  </span>
  <app-unities-dropdown
    *ngIf="loadedColUnits"
    [show]="column.visibleDropdown"
    [quantity]="column.quantity"
    [formName]="formName"
    [id]="column.relatedField"
    (selected)="setFieldUnit($event)"
  >
  </app-unities-dropdown>
</ng-container>
